const initialState = {
  accessToken: null,
  menus: [],
  userName: null,
  profileImage: null,
  userEmail: null,
  googleApiTime: null,
  userInfo: null,
  notificationCount: 0,
  firebaseToken: null,
  refId: null,
  forgotPassObj: null,
  microPhoneStatus: false,
  language: "en"
};

const profileReducer = (state = initialState, action: any) => {
  if (action.type === "ACCESS_TOKEN") {
    return {
      ...state,
      accessToken: action.payload,
    };
  } else if (action.type === "MENU") {
    return {
      ...state,
      menus: action.payload,
    };
  } else if (action.type === "USER_NAME") {
    return {
      ...state,
      userName: action.payload,
    };
  } else if (action.type === "USER_INFO") {
    return {
      ...state,
      userInfo: action.payload,
    };
  } else if (action.type === "UPDATE_PROFILE_IMAGE") {
    return {
      ...state,
      profileImage: action.payload,
    };
  } else if (action.type === "USER_EMAIL") {
    return {
      ...state,
      userEmail: action.payload,
    };
  } else if (action.type === "NOTIFICATION_COUNT") {
    return {
      ...state,
      notificationCount: action.payload,
    };
  } else if (action.type === "GOOGLE_API_TIME") {
    return {
      ...state,
      googleApiTime: action.payload,
    };
  } else if (action.type === "FIREBASE_TOKEN") {
    return {
      ...state,
      firebaseToken: action.payload,
    };
  } else if (action.type === "REF_ID") {
    return {
      ...state,
      refId: action.payload,
    };
  } else if (action.type === "FORGOT_PASS_OBJ") {
    return {
      ...state,
      forgotPassObj: action.payload,
    };
  } else if (action.type === "MICROPHONE_STATUS") {
    return {
      ...state,
      microPhoneStatus: action.payload,
    };
  } else if (action.type === "RESET_STATE") {
    return initialState;
  } else if (action.type === "LANGUAGE") {
    return {
      ...state,
      language: action.payload
    };
  }
  else {
    return state;
  }
};

export default profileReducer;
